import { getElementByQuerySelector } from '@/helpers';
import { INTERACTIVE_SVG_ID } from '@/constants';

import { getBuildedMatfileTemplate } from './matfile';

let zoomOutScaleCoef = 1;
let zoomInScaleCoef = 1;
let pageModeScaleCoef = 1;

export const getScaleCoefs = () => ({
  zoomOut: zoomOutScaleCoef,
  zoomIn: zoomInScaleCoef,
  pageMode: pageModeScaleCoef
});


export const mapScaleCoefIntoPercentage = (value) => {
  const { zoomOut } = getScaleCoefs();
  let convertedValue = Math.round(100 / zoomOut * value);
  return convertedValue;
}

export const mapPercentageIntoScaleCoef = (value) => {
  const {zoomOut} = getScaleCoefs();
  let convertedValue = zoomOut / 100 * value;
  return convertedValue;
}

export const isPointInsideRect = (
  pointX,
  pointY,
  x1,
  y1,
  rectWidth,
  rectHeight,
) => {
  const x2 = x1 + rectWidth;
  const y2 = y1 + rectHeight;
  return x1 <= pointX && x2 >= pointX && y1 <= pointY && y2 >= pointY;
};

export const getMinMaxPositions = figures => {
  let minX = Number.POSITIVE_INFINITY;
  let minY = Number.POSITIVE_INFINITY;
  let maxX = Number.NEGATIVE_INFINITY;
  let maxY = Number.NEGATIVE_INFINITY;
  figures.forEach((elem, index) => {
    const { contour } = elem;
    const type = Object.getOwnPropertyNames(contour)[0];
    const obj = contour[type];
    const { points } = obj;
    if (!obj.x) {
      if (points) {
        for (let i = 0; i < points.length; i += 2) {
          if (points[i] < minX) {
              minX = points[i];
          }
          if (points[i] > maxX) {
              maxX = points[i];
          }
        }
      } else {
        minX = 0;
        maxX = obj.w;
      }
    } else {
      if (obj.x < minX) {
          minX = obj.x;
      }
      if (obj.x + obj.w > maxX) {
          maxX = obj.x + obj.w;
      }
    }
    if (!obj.y) {
      if (points) {
        for (let i = 1; i < points.length; i += 2) {
          if (points[i] < minY) {
            minY = points[i];
          }
          if (points[i] > maxY) {
            maxY = points[i];
          }
        }
      } else {
        minY = 0;
        maxY = obj.h;
      }
    } else {
      if (obj.y < minY) {
        minY = obj.y;
      }
      if (obj.y + obj.h > maxY) {
        maxY = obj.y + obj.h;
      }
    }
  });
  return {
    minX,
    minY,
    maxX,
    maxY,
  };
};

export const getMinMaxShapesPositions = shapes => {
  let minX = Number.POSITIVE_INFINITY;
  let minY = Number.POSITIVE_INFINITY;
  let maxX = Number.NEGATIVE_INFINITY;
  let maxY = Number.NEGATIVE_INFINITY;
  shapes.forEach((shape, index) => {
    const { primitiveProps: geometry } = shape;
    const { points } = geometry;
    if (!geometry.x) {
      if (points) {
        for (let i = 0; i < points.length; i += 2) {
          if (points[i] < minX) {
            minX = points[i];
          }
          if (points[i] > maxX) {
            maxX = points[i];
          }
        }
      } else {
        minX = 0;
        maxX = geometry.w;
      }
    } else {
      if (geometry.x < minX) {
        minX = geometry.x;
      }
      if (geometry.x + geometry.w > maxX) {
        maxX = geometry.x + geometry.w;
      }
    }
    if (!geometry.y) {
      if (points) {
        for (let i = 1; i < points.length; i += 2) {
          if (points[i] < minY) {
            minY = points[i];
          }
          if (points[i] > maxY) {
            maxY = points[i];
          }
        }
      } else {
        minY = 0;
        maxY = geometry.h;
      }
    } else {
      if (geometry.y < minY) {
        minY = geometry.y;
      }
      if (geometry.y + geometry.h > maxY) {
        maxY = geometry.y + geometry.h;
      }
    }
  });
  return {
    minX,
    minY,
    maxX,
    maxY,
  };
};

export const recalcZoomBordersScaleCoefs = (newPageWidth) => {
  const matfileTemplate = getBuildedMatfileTemplate();

  // use matfileTemplate as source of default sizes
  if (matfileTemplate) {
    let { box: { r: pageWidth, b: pageHeight } } = matfileTemplate;

    pageWidth = newPageWidth? newPageWidth : pageWidth;
    const rendererRect = getElementByQuerySelector(`#${INTERACTIVE_SVG_ID}`).getBoundingClientRect();

    const wSizesRatio = rendererRect.width / rendererRect.height;
    const pSizesRatio = pageWidth / pageHeight;
    const calcScaleCoef = (isPreferWidth, offsetCoef, calcPageWidth) => {
      return (
        isPreferWidth
          ? (rendererRect.width / calcPageWidth)
          : (rendererRect.height / pageHeight)
      ) * offsetCoef;
    };

    zoomOutScaleCoef = calcScaleCoef((wSizesRatio < pSizesRatio), 0.7, pageWidth);
    zoomInScaleCoef = calcScaleCoef((wSizesRatio > pSizesRatio), 0.7, pageWidth);
  }
};